// Mock data para la clínica de medicina estética

export const clinicInfo = {
  name: "Qara",
  tagline: "Belleza Natural, Resultados Extraordinarios",
  description: "Centro de medicina estética de alta especialización, enfocado en tratamientos personalizados que realzan la belleza natural con respaldo científico.",
  phone: "+593 99 895 4887",
  phone2: "+593 99 046 8704",
  whatsapp: "+593998954887",
  whatsappNumber: "593998954887",
  email: "qara.mec@gmail.com",
  address: "Quito, Ecuador",
  hours: "Lunes a Viernes: 9:00 - 18:00 | Sábados: Bajo previa cita",
  socialMedia: {
    instagram: "https://www.instagram.com/qara.mec",
    whatsapp: "https://wa.me/593998954887?text=Hola%2C%20quisiera%20agendar%20una%20cita%20en%20Qara"
  }
};

export const serviceLabels = {
  mesoterapia: 'Mesoterapia Facial, Corporal y Capilar',
  skinboosters: 'Skinboosters',
  botox: 'Toxina Botulínica',
  peeling: 'Peelings de Grado Médico',
  alopecia: 'Manejo de Alopecia',
  labios: 'Perfilado de Labios',
  armonizacion: 'Armonización Facial',
  consulta: 'Consulta General'
};

export const services = [
  {
    id: 1,
    title: "Mesoterapia Facial, Corporal y Capilar",
    description: "Tratamiento revitalizante que nutre profundamente la piel del rostro, el cuerpo y el cuero cabelludo mediante microinyecciones de vitaminas y nutrientes esenciales.",
    icon: "Sparkles",
    image: "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9"
  },
  {
    id: 2,
    title: "Skinboosters",
    description: "Hidratación profunda de la piel con ácido hialurónico para mejorar la textura, luminosidad y elasticidad de forma natural.",
    icon: "Droplet",
    image: "https://images.unsplash.com/photo-1643684391140-c5056cfd3436"
  },
  {
    id: 3,
    title: "Toxina Botulínica",
    description: "Aplicación precisa en tercio superior facial y maseteros para suavizar líneas de expresión y lograr un rostro más relajado y armonioso.",
    icon: "Smile",
    image: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881"
  },
  {
    id: 4,
    title: "Peelings de Grado Médico",
    description: "Renovación celular profunda mediante exfoliación química controlada. Manejo especializado de enzimas para resultados óptimos.",
    icon: "Sparkle",
    image: "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9"
  },
  {
    id: 5,
    title: "Manejo Integral de Alopecia",
    description: "Tratamiento especializado y personalizado para la caída del cabello, combinando las técnicas más avanzadas.",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1643684391140-c5056cfd3436"
  },
  {
    id: 6,
    title: "Perfilado y Aumento de Labios",
    description: "Definición y volumen natural de los labios mediante técnicas precisas de ácido hialurónico.",
    icon: "Lips",
    image: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881"
  },
  {
    id: 7,
    title: "Armonización Facial",
    description: "Equilibrio y proporción facial mediante técnicas no invasivas para realzar tu belleza natural.",
    icon: "Star",
    image: "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9"
  }
];

export const philosophy = {
  title: "Nuestra Filosofía",
  subtitle: "Excelencia en Medicina Estética",
  content: "Creemos en la belleza natural potenciada con ciencia. Cada tratamiento está diseñado para respetar tu esencia única mientras alcanzamos resultados excepcionales. Nuestro enfoque combina técnicas médicas de vanguardia con un profundo respeto por la armonía facial y corporal.",
  values: [
    {
      title: "Personalización",
      description: "Cada paciente es único. Diseñamos tratamientos a medida según tus necesidades y objetivos."
    },
    {
      title: "Resultados Naturales",
      description: "Buscamos realzar tu belleza natural, no cambiarla. Resultados sutiles y armoniosos."
    },
    {
      title: "Excelencia Médica",
      description: "Formación continua y uso de las técnicas más avanzadas en medicina estética."
    },
    {
      title: "Ambiente Premium",
      description: "Instalaciones diseñadas para tu comodidad en un entorno de lujo y tranquilidad."
    }
  ],
  image: "https://images.pexels.com/photos/5327864/pexels-photo-5327864.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
};

export const team = [
  {
    id: 1,
    name: "Dra. Jessica Nicolalde",
    title: "Médico Especialista en Medicina Estética",
    description: "Médico especialista dedicada a realzar la belleza natural de cada paciente mediante técnicas avanzadas y personalizadas en medicina estética. Comprometida con la excelencia y la formación continua en los últimos avances del sector.",
    expertise: [
      "Mesoterapia facial, corporal y capilar",
      "Aplicación de toxina botulínica",
      "Skinboosters y bioestimulación",
      "Peelings de grado médico",
      "Manejo integral de alopecia",
      "Perfilado y aumento de labios",
      "Armonización facial"
    ],
    image: "https://static.prod-images.emergentagent.com/jobs/98ae2a97-58d7-4c50-839c-e8f6b07e0b65/images/ce3c9177509b01a1cb3686334833b21131ddce6fb5c0b414e94fe67efad9c1ca.jpeg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María G.",
    treatment: "Skinboosters",
    comment: "Resultados increíbles y naturales. La atención es excepcional y el ambiente muy profesional.",
    rating: 5
  },
  {
    id: 2,
    name: "Laura S.",
    treatment: "Toxina Botulínica",
    comment: "Me encantó el resultado, muy natural. La doctora es muy profesional y explica todo el proceso.",
    rating: 5
  },
  {
    id: 3,
    name: "Carmen R.",
    treatment: "Mesoterapia Facial",
    comment: "Mi piel luce radiante. Un tratamiento que realmente funciona en un ambiente de lujo.",
    rating: 5
  }
];
